import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-4xl mx-auto px-6 py-16" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "flex items-center gap-2 mb-4" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "text-center py-16"
}
const _hoisted_6 = {
  key: 1,
  class: "text-center py-16 bg-white rounded-lg border border-gray-200"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 2,
  class: "space-y-8"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_WatchlistCard = _resolveComponent("WatchlistCard")!
  const _component_WatchlistDetailsModal = _resolveComponent("WatchlistDetailsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          innerHTML: _ctx.EYE_ICON,
          class: "text-gray-600"
        }, null, 8, _hoisted_4),
        _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "text-2xl font-bold text-gray-900" }, "My Watchlist", -1))
      ]),
      _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-sm text-gray-500 mb-8" }, " Your saved searches that you've added to get updates. ", -1)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-primary-purple mx-auto" }, null, -1)
          ]))]))
        : (_ctx.watchlistItems.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", {
                innerHTML: _ctx.EYE_ICON,
                class: "mx-auto mb-4 text-gray-300 w-16 h-16"
              }, null, 8, _hoisted_7),
              _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 mb-2" }, " No watchlist items ", -1)),
              _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-gray-500 mb-4" }, " Add searches from the Search page to get updates when new transcripts match. ", -1)),
              _createVNode(_component_router_link, {
                to: { name: 'InsightsSearch' },
                class: "inline-flex items-center gap-1 text-sm font-medium text-primary-purple hover:underline"
              }, {
                default: _withCtx(() => [
                  _cache[10] || (_cache[10] = _createTextVNode(" Go to Search ", -1)),
                  _createElementVNode("span", { innerHTML: _ctx.ARROW_RIGHT_ICON }, null, 8, _hoisted_8)
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_ctx.recentlyUpdatedItems.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900 mb-4" }, " Recently Updated ", -1)),
                    _createElementVNode("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentlyUpdatedItems, (item) => {
                        return (_openBlock(), _createBlock(_component_WatchlistCard, {
                          key: item.id,
                          item: item,
                          "open-menu-id": _ctx.openMenuId,
                          onClick: ($event: any) => (_ctx.handleCardClick(item)),
                          onToggleMenu: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openMenuId = _ctx.openMenuId === $event ? null : $event)),
                          onViewDetails: _cache[1] || (_cache[1] = ($event: any) => {
                _ctx.viewDetailsItem = $event;
                _ctx.openMenuId = null;
              }),
                          onRemove: _cache[2] || (_cache[2] = ($event: any) => {
                _ctx.handleRemove($event);
                _ctx.openMenuId = null;
              })
                        }, null, 8, ["item", "open-menu-id", "onClick"]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.otherItems.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900 mb-4" }, "Other", -1)),
                    _createElementVNode("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherItems, (item) => {
                        return (_openBlock(), _createBlock(_component_WatchlistCard, {
                          key: item.id,
                          item: item,
                          "open-menu-id": _ctx.openMenuId,
                          onClick: ($event: any) => (_ctx.handleCardClick(item)),
                          onToggleMenu: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openMenuId = _ctx.openMenuId === $event ? null : $event)),
                          onViewDetails: _cache[4] || (_cache[4] = ($event: any) => {
                _ctx.viewDetailsItem = $event;
                _ctx.openMenuId = null;
              }),
                          onRemove: _cache[5] || (_cache[5] = ($event: any) => {
                _ctx.handleRemove($event);
                _ctx.openMenuId = null;
              })
                        }, null, 8, ["item", "open-menu-id", "onClick"]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
    ]),
    _createVNode(_component_WatchlistDetailsModal, {
      show: !!_ctx.viewDetailsItem,
      item: _ctx.viewDetailsItem,
      "program-name": _ctx.userStore.selectedProgram?.name ?? '',
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.viewDetailsItem = null)),
      onUpdated: _cache[7] || (_cache[7] = ($event: any) => (_ctx.viewDetailsItem = null))
    }, null, 8, ["show", "item", "program-name"])
  ]))
}